const setBusinessType = (id = null, val = null) => {
  return {
    type: 'SET_BUSINESSTYPE',
    id,
    data: val,
  }
}

export default {
  setBusinessType,
}
